import {
  DashboardCryptoData,
  Notification,
  TransactionsType,
  cryptoReport,
} from "pages/MyAccounts/type";

// img
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";

const walletOptions: DashboardCryptoData[] = [
  {
    id: 1,
    series: [0, 0, 0],
    availablebalance: 0,
    income: 0,
    Expense: 0,
    USDC: {
      USDC: 0,
      Dollar: 0,
    },
    Bitcoin: {
      BTC: 0,
      Dollar: 0,
    },
    USD: {
      USD: 0,
      Dollar: 0,
    },
  },
  {
    id: 2,
    series: [0, 0, 0],
    availablebalance: 0,
    income: 0,
    Expense: 0,
    USDC: {
      USDC: 0,
      Dollar: 0,
    },
    Bitcoin: {
      BTC: 0,
      Dollar: 0,
    },
    USD: {
      USD: 0,
      Dollar: 0,
    },
  },
  {
    id: 3,
    series: [0, 0, 0],
    availablebalance: 0,
    income: 0,
    Expense: 0,
    USDC: {
      USDC: 0,
      Dollar: 0,
    },
    Bitcoin: {
      BTC: 0,
      Dollar: 0,
    },
    USD: {
      USD: 0,
      Dollar: 0,
    },
  },
  {
    id: 4,
    series: [0, 0, 0],
    availablebalance: 0,
    income: 0,
    Expense: 0,
    USDC: {
      USDC: 0,
      Dollar: 0,
    },
    Bitcoin: {
      BTC: 0,
      Dollar: 0,
    },
    USD: {
      USD: 0,
      Dollar: 0,
    },
  },
];

const transactionsDataALL: TransactionsType[] = [
  {
    id: 1,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0 BTC",
    price: "$0",
  },
  {
    id: 2,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
  {
    id: 3,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "LTC",
    date: "16 Mar, 2020",
    amount: "1.88 LTC",
    price: "$94.22",
  },
  {
    id: 4,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "ETH",
    date: "17 Mar, 2020",
    amount: "0.42 ETH",
    price: "$84.32",
  },
  {
    id: 5,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "BTC",
    date: "18 Mar, 2020",
    amount: "0.018 BTC",
    price: "$145.80",
  },
  {
    id: 6,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0.016 BTC",
    price: "$125.20",
  },
  {
    id: 7,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
];
const transactionsDataBuy: TransactionsType[] = [
  {
    id: 1,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
  {
    id: 2,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0.016 BTC",
    price: "$125.20",
  },
  {
    id: 3,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "ETH",
    date: "17 Mar, 2020",
    amount: "0.42 ETH",
    price: "$84.32",
  },
  {
    id: 4,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "LTC",
    date: "16 Mar, 2020",
    amount: "1.88 LTC",
    price: "$94.22",
  },
  {
    id: 5,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0.016 BTC",
    price: "$125.20",
  },
  {
    id: 6,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "BTC",
    date: "18 Mar, 2020",
    amount: "0.018 BTC",
    price: "$145.80",
  },
  {
    id: 7,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
];

const transactionsDataSell: TransactionsType[] = [
  {
    id: 1,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0.016 BTC",
    price: "$125.20",
  },
  {
    id: 2,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "LTC",
    date: "16 Mar, 2020",
    amount: "1.88 LTC",
    price: "$94.22",
  },
  {
    id: 3,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "ETH",
    date: "17 Mar, 2020",
    amount: "0.42 ETH",
    price: "$84.32",
  },
  {
    id: 4,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
  {
    id: 5,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "BTC",
    date: "18 Mar, 2020",
    amount: "0.018 BTC",
    price: "$145.80",
  },
  {
    id: 6,
    icon: "bx-up-arrow-circle",
    color: "danger",
    type: "Sell",
    currency: "ETH",
    date: "15 Mar, 2020",
    amount: "0.56 ETH",
    price: "$112.34",
  },
  {
    id: 7,
    icon: "bx-down-arrow-circle",
    color: "primary",
    type: "Buy",
    currency: "BTC",
    date: "14 Mar, 2020",
    amount: "0.016 BTC",
    price: "$125.20",
  },
];

const notificationsData: Notification[] = [
  {
    id: 1,
    avatar: img1,
    title: "Donec vitae sapien ut",
    description:
      "If several languages coalesce, the grammar of the resulting language",
    author: "Joseph",
    date: "12 Mar, 2020",
  },
  {
    id: 2,
    avatar: img2,
    title: "Cras ultricies mi eu turpis",
    description:
      "To an English person, it will seem like simplified English, as a skeptical cambridge",
    author: "Jerry",
    date: "13 Mar, 2020",
  },
  {
    id: 3,
    avatar: img3,
    title: "Duis arcu tortor suscipit",
    description:
      "It va esser tam simplic quam occidental in fact, it va esser occidental.",
    author: "Calvin",
    date: "14 Mar, 2020",
  },
  {
    id: 4,
    avatar: img1,
    title: "Donec vitae sapien ut",
    description:
      "If several languages coalesce, the grammar of the resulting language",
    author: "Joseph",
    date: "12 Mar, 2020",
  },
];

const cryptoReports: cryptoReport[] = [
  {
    title: " Bitcoin",
    icon: "mdi mdi-bitcoin",
    color: "warning",
    value: "$ 0",
    desc: "0",
    series: [
      {
        name: "BTC",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: { sparkline: { enabled: !0 } },
      stroke: { curve: "smooth", width: 2 },
      colors: ["#f1b44c"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [25, 100, 100, 100],
        },
      },
      tooltip: {
        fixed: { enabled: false },
        x: { show: false },
        marker: { show: false },
      },
    },
    arrowUpDown: "mdi mdi-arrow-up ms-1 text-success",
  },
  {
    title: " USDC",
    icon: "mdi mdi-currency-usd",
    color: "primary",
    value: "$ 0",
    desc: "0",
    series: [
      {
        name: "USDC",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: { sparkline: { enabled: !0 } },
      stroke: { curve: "smooth", width: 2 },
      colors: ["#556ee6"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [25, 100, 100, 100],
        },
      },
      tooltip: {
        fixed: { enabled: false },
        x: { show: false },
        marker: { show: false },
      },
    },
    arrowUpDown: "mdi mdi-arrow-down ms-1 text-danger",
  },
  {
    title: "USD",
    icon: "mdi mdi-currency-usd",
    color: "info",
    value: "$ 0",
    desc: "0 ",
    series: [
      {
        name: "USD",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
    options: {
      chart: { sparkline: { enabled: !0 } },
      stroke: { curve: "smooth", width: 2 },
      colors: ["#50a5f1"],
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.45,
          opacityTo: 0.05,
          stops: [25, 100, 100, 100],
        },
      },
      tooltip: {
        fixed: { enabled: false },
        x: { show: false },
        marker: { show: false },
      },
    },
    arrowUpDown: "mdi mdi-arrow-up ms-1 text-success",
  },
];

export {
  walletOptions,
  transactionsDataALL,
  transactionsDataSell,
  transactionsDataBuy,
  notificationsData,
  cryptoReports,
};
